import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";

import { stripeCancelMembership } from "../actions/membership";
import { getCurrentUser } from "../actions/user";

import Footer from '../components/Footer'
import loadingIcon from "../assets/images/loading-dark.svg"
import community from "../assets/images/community.svg"

// "Before you go" step: each reason maps to Stripe's cancellation_details.feedback value
// (checked again in gnjAmplifyStripeCancelMembership).
export const CANCEL_REASONS = [
  { value: "too_expensive", label: "Too expensive" },
  { value: "unused", label: "Not using it enough" },
  { value: "missing_features", label: "Missing a feature" },
  { value: "switched_service", label: "Found something else" },
  { value: "other", label: "Other" }
];
export const CANCEL_COMMENT_MAX = 500;

export class CancelConfirm extends Component{
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      isLoading: false,
      reason: "",
      comment: ""
    };
  }

  _onReasonChange = (e) => {
    this.setState({ reason: e.target.value });
  }

  _onCommentChange = (e) => {
    this.setState({ comment: e.target.value });
  }

  _cancelMembership = async () => {
    const { currentUser } = this.props.user
    const { reason, comment } = this.state
    // The reason and comment are optional: with neither, the cancel goes through as before.
    const ask = window.confirm("Cancel my membership?");
    if (!ask) return;
    this.setState({ error: "", isLoading: true });
    const cancelMembership  = await this.props.stripeCancelMembership(
      currentUser.attributes["custom:stripeSubscriptionId"],
      true,
      { reason, comment: comment.trim() }
    )
    if(cancelMembership && cancelMembership.subscription){
      await this.props.getCurrentUser();
      this.setState({
        error: "",
        isLoading: false
      });
      this.props.history.push("/my-account/billing")
    } else {
      this.setState({ error: "Error occurred. Please try again.", isLoading: false });
    }
  }

  render() {
    const { error, isLoading, reason, comment } = this.state
    
    return(
      <div>
        <div className="Billing Container Container--md Container--side-padding">
          <h1>Cancel membership</h1>
          
          <div>
            <h3>Are you sure you want to cancel your membership?</h3>
            <p>You will lose access to all member-only features at the end of your current membership cycle.</p>

            <div className="Container Container--sm">
              <p><img src={community} alt="Being a member means" /></p>
            </div>

            <p>Your membership helps us out a lot! Your membership dues goes to running this app smoothly, to improving existing features, and in releasing new features that make writing a journal more enjoyable!</p>

            <p><Link to="/feedback" id="cancel_tell_us_feedback_link">Give us feedback to serve you better!</Link></p>

            <fieldset className="cancel-reasons" id="cancel_reason" disabled={isLoading}>
              <legend><h3>Before you go — what's the main reason?</h3></legend>
              {CANCEL_REASONS.map(({ value, label }) => (
                <label key={value} htmlFor={`cancel_reason_${value}`}>
                  <input
                    type="radio"
                    name="cancel_reason"
                    id={`cancel_reason_${value}`}
                    value={value}
                    checked={reason === value}
                    onChange={this._onReasonChange}
                  />
                  <span>{label}</span>
                </label>
              ))}
            </fieldset>

            <div className="cancel-comment">
              <label htmlFor="cancel_reason_comment">Anything else you'd like to tell us? <small>(optional)</small></label>
              <textarea
                id="cancel_reason_comment"
                rows={3}
                maxLength={CANCEL_COMMENT_MAX}
                value={comment}
                onChange={this._onCommentChange}
                disabled={isLoading}
              />
            </div>

            <p>Your private entries stay yours either way — you can always come back.</p>
            {error ? <p className="error-msg" role="alert">{error}</p> : ''}
            <div className="cancel-confirm-buttons">
              <button className="btn-secondary" onClick={() => this.props.history.push('/')} id="cancel_keep_my_membership" disabled={isLoading}>No, keep my membership</button>
              <button className="btn-secondary" onClick={this._cancelMembership} disabled={isLoading} id="cancel_cancel_my_membership">
                {isLoading ? 
                  <img
                    alt="Loading..."
                    className="loading-icon"
                    src={loadingIcon}
                  /> 
                : "Yes, cancel my membership" }
              </button>
            </div>
          </div>

          <div>
            <Footer />
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      stripeCancelMembership,
      getCurrentUser
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CancelConfirm);